<template>
    <div class="main">
        <a-card :loading="tableLoading" style="border-radius: 20px;" :bordered="false">
            <div class="actions">
            <router-link to="/vaccine-templates"
                style="font-size:14px;text-decoration:none;line-height:30px;color:#98c14b;display:flex">
                <p>
                    <a-icon type="double-left" />
                </p>
                <p>Back To Vaccine Template</p>

            </router-link>
        </div>
        
        
        <div class="card-container mt-2">
            <div>
                <h3 style="font-size:18;line-height:45px">Template Details</h3>
            </div>
            <div>
                <a-row class="pb-2">
                    <a-col :span="8">
                        <div style="font-size:15;">Template Name: </div>
                    </a-col>
                    <a-col :span="8" :offset="4">
                        <div style="font-size:15;">{{ templateDetail.name ? templateDetail.name : 'N/A' }}</div>
                    </a-col>
                </a-row>
                <a-row class="pb-2">
                    <a-col :span="8">
                        <div style="font-size:15;">Target Species: </div>
                    </a-col>
                    <a-col :span="8" :offset="4">
                        <div style="font-size:15;">{{ templateDetail.poultrySpeciesLabel ? templateDetail.poultrySpeciesLabel : "N/A"  }}</div>
                    </a-col>
                </a-row>
                <a-row class="pb-2">
                    <a-col :span="8">
                        <div style="font-size:15;">Start Age(days): </div>
                    </a-col>
                    <a-col :span="8" :offset="4">
                        <div style="font-size:15;">{{ templateDetail.startAge ? templateDetail.startAge : 0 }}</div>
                    </a-col>
                </a-row>
                <a-row class="pb-2">
                    <a-col :span="8">
                        <div style="font-size:15;">End Age(days): </div>
                    </a-col>
                    <a-col :span="8" :offset="4">
                        <div style="font-size:15;">{{ templateDetail.endAge ? templateDetail.endAge : 0  }}</div>
                    </a-col>
                </a-row>
                <a-row class="pb-2">
                    <a-col :span="8">
                        <div style="font-size:15;">Status: </div>
                    </a-col>
                    <a-col :span="8" :offset="4">
                        <div style="font-size:15;">{{ templateDetail.templateStatusLabel ? templateDetail.templateStatusLabel : "N/A" }}</div>
                    </a-col>
                </a-row>
                <a-row class="pb-2">
                    <a-col :span="8">
                        <div style="font-size:15;">No of Vaccines Scheduled: </div>
                    </a-col>
                    <a-col :span="8" :offset="4">
                        <div style="font-size:15;">{{ templateDetail.templateProducts ? templateDetail.templateProducts.length : 0 }}</div>
                    </a-col>
                </a-row>
            </div>
        </div>

        <div class="mt-5">
            <div class="actions">
                <h3 style="font-size:28px;line-height:45px">Vaccination Chart</h3>
                <div style="display:flex; justify-content: space-around;">
                    <a-button @click="showVaccineModal" style="border-raduis:6px; background: #fff;color:#0F3659; margin-right:10px;" >
                        <a-icon type="plus" /> Add Product
                    </a-button>
                </div>
            </div>
            <a-table
                :columns="vaccineColumns"
                :data-source="templateDetail.templateProducts"
                :pagination="pagination"
                :loading='tableLoading'
                :scroll="{ x: 1500, y: 600 }"
                class="tableStyle"
            >
    
            </a-table>
        </div>
        </a-card>
        <a-modal
            class="modalStyle"
            :visible="addVaccineVisible"
            :footer="null"
            width="700px"
            @cancel="closeVaccineModal"
            >
            <p style="text-align:center;font-weight: bolder;padding-top: 10px;">Add Product</p>
            <div style="display:flex;justify-content: center;">
                <a-form-model
                    ref="addVaccineRef"
                    :model="addVaccineModel"
                    :rules="rules"
                >
                    <a-row justify="space-between">
                        <a-col >
                            <a-form-model-item label="Product" ref="id" prop="id">
                                <a-select @change="onChangeProduct" v-model="addVaccineModel.id" placeholder="please select your product">
                                    <a-select-option  v-for="product in products.data" :key="product.id"
                                        v-bind:value="product.id">
                                        {{ product.brandName }}
                                    </a-select-option>
                                </a-select>
                            </a-form-model-item>
                        </a-col>
                        <a-col >
                            <a-form-model-item label="Category" ref="category" prop="category">
                                <a-input
                                    class=""
                                    v-model="addVaccineModel.category"
                                    disabled
                                />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Manufacturer" ref="manufacturer" prop="manufacturer">
                                <a-input
                                    class=""
                                    v-model="addVaccineModel.manufacturer"
                                    disabled
                                />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="10" :offset="4">
                            <a-form-model-item label="Age of Administration(days)" ref="applicationAge" prop="applicationAge">
                                <a-input
                                    class=""
                                    v-model="addVaccineModel.applicationAge"
                                />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-col :span="10" :offset="0">
                            <a-form-model-item label="Doses per Vial" ref="doseNumber" prop="doseNumber">
                                <a-input
                                    class=""
                                    v-model="addVaccineModel.doseNumber"
                                />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="10" :offset="4">
                            <a-form-model-item label="Remind By(days)" ref="remindBy" prop="remindBy">
                                <a-input
                                    class=""
                                    v-model="addVaccineModel.remindBy"
                                />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row>
                        <a-form-model-item label="Special Instructions" ref="notes" prop="notes">
                            <a-textarea
                            v-model="addVaccineModel.notes"
                            placeholder=""
                            :auto-size="{ minRows: 3, maxRows: 5 }"
                            />
                        </a-form-model-item>
                    </a-row>
                </a-form-model>

            </div>

            <div style="display: flex;justify-content: center;padding-top:30px">
                <a-button @click="handleAddVaccine" :loading="loading" style="background: #418a49;color:#fff;border-radius:5px;">
                    Add Product 
                </a-button>
            </div>
        </a-modal>
    </div>

</template>

<script>
import moment from 'moment';
// import XLSX from "xlsx";
// import _ from 'lodash';
import { mapGetters, mapActions } from 'vuex';
// import Invoice from './custom/Invoice.vue'
// import DownloadInvoice from './custom/DownloadInvoice.vue'


const vaccineColumns = [
    {
        title: 'Vaccination Name',
        dataIndex: 'productName',
        key: 'productName',
        // width: 150,
    },
    {
        title: 'Category',
        dataIndex: 'productCategory',
        key: 'productCategory'
        // width: 200,
    },
    {
        title: 'Manufacturer',
        dataIndex: 'productManufacturer',
        key: 'productManufacturer',
        //  width: 150,
    },
    {
        title: 'Doses per Vial',
        dataIndex: 'doseNumber',
        key: 'doseNumber',
        // width: 150,
    },
    {
        title: 'Age of Administration',
        dataIndex: 'applicationAge',
        key: 'applicationAge',
        // width: 150,
    },
    {
        title: 'Remind By',
        dataIndex: 'remindBy',
        key: 'remindBy',
        // width: 150,
    },

];

export default {
    name: 'VaccineTemplateDetails',
    // props: ['items'],
    components: {
        // Invoice,
        // DownloadInvoice
    },
    data() {
        return {
            products: [],
            templateDetail: {},
            addVaccineVisible: false,
            data: [],
            vaccineColumns,
            dateFormat: 'DD/MM/YYYY',
            startDate: moment(),
            endDate: moment(),
            params: {
                page: -1,
                perPage: -1,
                searchBy: {},
                sortBy: {}
            },
            pagination: {
                pageSize: 20
            },
            selectedProduct: {},
            tableLoading: false,
            addVaccineModel: {
                id: '',
                category: '',
                manufacturer: '',
                applicationAge: '',
                doseNumber: '',
                remindBy: '',
                notes: ''
            },
            id: '',
            loading: false,
            rules:{
                id: [
                    { required: true, message: 'Please select product' , trigger: 'change'},
                ],
                category: [
                        { required: true, message: 'Please select product' , trigger: 'change'},

                    ],
                manufacturer: [
                    { required: true, message: 'Please select product', trigger: 'change' },
                ],
                applicationAge: [
                    { required: true, message: 'Please select your age', trigger: 'change' },
                ],
                doseNumber: [
                    { required: true, message: 'Please enter dose number', trigger: 'change' },
                ],
                remindBy: [
                    { required: true, message: 'Please enter remindBy', trigger: 'change' },
                ],
                notes: [
                    { required: true, message: 'Please enter notes', trigger: 'change' },
                ],
            }
            
        }
    },
    methods: {
        ...mapActions(['getRetailerAndCategoryAndOrders']),
        onChange(date, dateString) {
            // console.log(date, dateString);
            this.startDate = dateString[0];
            this.endDate = dateString[1];
            // console.log("startDate | ", this.startDate);
            // console.log("endDate | ", this.endDate);
        },
        moment,
        showVaccineModal(){
            this.addVaccineVisible = true;
        },
        closeVaccineModal(){
            this.addVaccineVisible = false;
        },
        showSuccessAlert(message) {
            this.$notification['success']({
                message: message,
            });
        },

        onChangeProduct(){
            const productId = this.addVaccineModel.id
            const selectedProduct = this.products?.data?.find((product) => product.id === productId)
            if (selectedProduct) {
                this.selectedProduct = selectedProduct
                this.addVaccineModel.category = this.selectedProduct?.categoryName ?? 'N/A'
                this.addVaccineModel.manufacturer = this.selectedProduct?.manufacturerName ?? 'N/A'
            }
        },

        handleAddVaccine(){
            this.$refs.addVaccineRef.validate(async valid => {
                if (valid) {
                    this.loading = true;
                    
                    const request = {
                        id: this.id,
                        data: {
                            productId: parseInt(this.addVaccineModel.id),
                            applicationAge: parseInt(this.addVaccineModel.applicationAge),
                            doseNumber: parseInt(this.addVaccineModel.doseNumber),
                            remindBy: parseInt(this.addVaccineModel.remindBy),
                            notes: this.addVaccineModel.notes
                        }
                    }
  
                    const response = await this.$store.dispatch("vaccineTemplate/addVaccine", request);
                         
                    this.loading = false
                    if(response.status === 200){
                        this.showSuccessAlert("New Vaccine Created Successfully")
                        this.getTemplateDetails();
                        this.addVaccineModel = {
                            id: '',
                            category: '',
                            manufacturer: '',
                            applicationAge: '',
                            doseNumber: '',
                            remindBy: '',
                            notes: ''
                        }
                        this.addVaccineVisible = false;
                    }else{
                        this.showErrorAlert(response.data.messages)
                    }
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },

        showErrorAlert(message) {
            this.$notification['error']({
                message: message
            });
        },
        
        async getProducts(){
            const request = {
                page: -1,
                perPage: -1,
                searchBy: {},
                sortBy: {
                    "'brandName'": 'desc'
                }
            }
            const response = await this.$store.dispatch('vaccineTemplate/getProducts', request);
            if (response.status === 200) {
                this.products = response.data;
            } else {
                // console.log("Error | ", response);
                this.showErrorAlert(`Something went wrong,try again later`)
            }
        },

        async getTemplateDetails(){
            this.id = this.$route.params.id;
            this.tableLoading = true;
            const response = await this.$store.dispatch('vaccineTemplate/getTemplateById', this.id);
            this.tableLoading = false;
            if (response.status === 200) {
                this.templateDetail = response.data;
            } else {
                // console.log("Error | ", response);
                this.showErrorAlert(`Something went wrong,try again later`)
            }
        },
        
    },
    computed: {
        ...mapGetters(['getCustomer']),
        displayDate() {
            return moment(this.retailerExtraDetails.createdAt).format("DD-MMM-YYYY")
        },
        displayTotalShopCategory() {
            return this.tableShopCategories.length
        },
        displayTotalCustomerOrders() {
            return this.tableCustomerOrders.length
        }
    },
    created() {
        
        this.getTemplateDetails();
        this.getProducts();
        // if (this.getCustomer) {
        //     this.retailerDetails = this.getCustomer
        //     this.loadRetailerCategoryAndOrders()
        //     // console.log("tableData2| ", this.tableData2)
        // }

    }
}
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.customerTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.actionIcons {
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.customerTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.customerTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.customerTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

a {
    color: #777777;
}

a:hover {
    color: #777777;
}

button:hover {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

button {
    color: #418a49;
    outline-color: #418a49;
    border-color: #418a49;
}

.card-container {
    background: none;
    overflow: hidden;
    /* padding: 24px; */
}

.card-container>.ant-tabs-card>.ant-tabs-content {
    height: 120px;
    margin-top: -16px;
}

.card-container>.ant-tabs-card>.ant-tabs-content>.ant-tabs-tabpane {
    background: #fff;
    padding: 16px;

}

.card-container>>>.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
    height: 40px;
    color: #98c14b;
    background: #e5efe7;
    border-color: #e5efe7;
    border-bottom: 1px solid #98c14b;
}

.tableStyle >>> .ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle >>> .ant-table-header  {
    background: #fff !important;
}


.card-container>>>.ant-tabs-tab {
    height: 40px;
    margin: 0;
    width: 217px;
    margin-right: 2px;
    padding: 0 16px;
    line-height: 38px;
    background: #fafafa;
    border: 1px solid #e8e8e8;

}

.card-container>>>.ant-tabs-tab:hover {
    color: #98c14b;
    /* background: #e5efe7; */
}

.card-container>>>.ant-badge-count {
    z-index: auto;
    min-width: 20px;
    height: 20px;
    padding: 0 6px;
    color: #fff;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    white-space: nowrap;
    text-align: center;
    background: #98c14b;
    border-radius: 10px;
    box-shadow: 0 0 0 1px #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar {
    border-color: #fff;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab {
    border-color: transparent;
    background: transparent;
}

.card-container>.ant-tabs-card>.ant-tabs-bar .ant-tabs-tab-active {
    border-color: #e5efe7;
    background: #e5efe7;
}

.requestActions {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
}

.tableStyle >>> .ant-table-tbody > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected) > td {
    background: #26A246;
    color: #fff;
  
}
</style>